module.exports = __webpack_public_path__ + "static/media/CE3.ad736ab8.jpg";